import React from 'react';

const LocationIcon = () => {
	const fillId = `location-icon-${Math.random().toString(36).substring(2, 11)}`;
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
		>
			<g clipPath="url(#clip0_7404_6933)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M11.1492 22.6651C8.3811 18.5498 3.61112 12.8299 4.02529 7.89581C4.3722 3.82493 8.03538 1 12 1C15.9646 1 19.6277 3.82493 19.9747 7.89581C20.3887 12.8299 15.6189 18.5498 12.8508 22.6651C12.6722 22.9645 12.3491 23.1483 12.0001 23.1483C11.6511 23.1483 11.3278 22.9645 11.1492 22.6651ZM12 5.9764C10.824 5.9764 9.76367 6.68467 9.31353 7.77082C8.86338 8.858 9.1122 10.1083 9.94435 10.9393C10.7755 11.7715 12.0258 12.0203 13.1129 11.5702C14.199 11.12 14.9073 10.0597 14.9073 8.88374C14.9073 7.27828 13.6054 5.9764 12 5.9764Z"
					fill={`url(#${fillId})`}
				/>
			</g>
			<defs>
				<linearGradient
					id={fillId}
					x1="23.7391"
					y1="12.0742"
					x2="0.0869568"
					y2="12.0742"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#01B1D5" />
					<stop offset="1" stopColor="#06038D" />
				</linearGradient>
				<clipPath id="clip0_7404_6933">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export default LocationIcon;
